import { Injectable } from '@angular/core';
import { HttpServiceBase as HttpService } from '@skylab-shared/core';
import { Wrapper } from '../wrapper/wrapper';

export { HttpService as HttpServiceBase };

@Injectable({providedIn: 'root'})
@Wrapper(HttpService, { static: true })
export class Http {}
